export class AuthContract {

    async login(credentials) {
        throw new Error(`${this.constructor.name}: login(credentials) is not implemented.`);
    }

    async logout() {
        throw new Error(`${this.constructor.name}: logout() is not implemented.`);
    }

    async refresh(options = {}) {
        throw new Error(`${this.constructor.name}: refresh(options) is not implemented.`);
    }

    async getUser(options = {}) {
        throw new Error(`${this.constructor.name}: getUser(options) is not implemented.`);
    }

}
